import React from 'react';
import {View} from 'react-native';

import ViewContainer from '../../components/layout/viewContainer';
import {ThemeContext} from '../../contextAPI/themeContext';
import PurchasedTopsResultList from './purchasedTopsListing';
import {purchasedTopsStyle} from './purchasedTops.style';

const PurchasedTopsScreen = (): JSX.Element => {
  const {ColorTheme} = React.useContext(ThemeContext);
  const {styles, ids} = purchasedTopsStyle(ColorTheme);
  return (
    <ViewContainer>
      <View style={styles.mainContainer} dataSet={{media: ids.mainContainer}}>
        <PurchasedTopsResultList />
      </View>
    </ViewContainer>
  );
};
export default React.memo(PurchasedTopsScreen);
